import { createSlice } from "@reduxjs/toolkit";
import {
  connectFacebookAccount,
  createFacebookPost,
  updateFacebookPost,
  getFacebookPost,
  getFacebookPostDetails,
  deleteFacebookPost,
} from "./thunk";

const initialState = {
  facebookData: [],
  facebookLoading: false,
  facebookAuthData: null,
  deleteLoading: false,
  error: null,
};

const facebookSlice = createSlice({
  name: "facebook",
  initialState,
  reducers: {
    resetFacebookData: (state) => {
      state.facebookLoading = false;
      state.facebookData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Connect Facebook
      .addCase(connectFacebookAccount.pending, (state) => {
        state.facebookLoading = true;
        state.error = null;
      })
      .addCase(connectFacebookAccount.fulfilled, (state, action) => {
        state.facebookLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(connectFacebookAccount.rejected, (state, action) => {
        state.facebookLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Create post
      .addCase(createFacebookPost.pending, (state) => {
        state.facebookLoading = true;
        state.error = null;
      })
      .addCase(createFacebookPost.fulfilled, (state, action) => {
        state.facebookLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(createFacebookPost.rejected, (state, action) => {
        state.facebookLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Update post
      .addCase(updateFacebookPost.pending, (state) => {
        state.facebookLoading = true;
        state.error = null;
      })
      .addCase(updateFacebookPost.fulfilled, (state, action) => {
        state.facebookLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(updateFacebookPost.rejected, (state, action) => {
        state.facebookLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post
      .addCase(getFacebookPost.pending, (state) => {
        state.facebookLoading = true;
        state.error = null;
      })
      .addCase(getFacebookPost.fulfilled, (state, action) => {
        state.facebookLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(getFacebookPost.rejected, (state, action) => {
        state.facebookLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post details
      .addCase(getFacebookPostDetails.pending, (state) => {
        state.facebookLoading = true;
        state.error = null;
      })
      .addCase(getFacebookPostDetails.fulfilled, (state, action) => {
        state.facebookLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(getFacebookPostDetails.rejected, (state, action) => {
        state.facebookLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Delete post
      .addCase(deleteFacebookPost.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteFacebookPost.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.facebookData = action.payload;
      })
      .addCase(deleteFacebookPost.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFacebookData } = facebookSlice.actions;
export default facebookSlice.reducer;
